var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,2 C12.8659932,2 16,5.13400675 16,9 C16,10.6448881 15.4326508,12.1572647 14.4829655,13.3521166 L17.7656854,16.6343146 C18.0781049,16.946734 18.0781049,17.453266 17.7656854,17.7656854 C17.453266,18.0781049 16.946734,18.0781049 16.6343146,17.7656854 L16.6343146,17.7656854 L13.3521166,14.4829655 C12.1572647,15.4326508 10.6448881,16 9,16 C5.13400675,16 2,12.8659932 2,9 C2,5.13400675 5.13400675,2 9,2 Z M9,4 C6.23857625,4 4,6.23857625 4,9 C4,11.7614237 6.23857625,14 9,14 C10.2594364,14 11.4101147,13.5343515 12.2892636,12.7658258 C12.3275393,12.6585247 12.3893824,12.5592468 12.4743146,12.4743146 C12.5595199,12.3891093 12.6591633,12.3271418 12.7653695,12.2884121 L12.809543,12.2385767 C13.5519747,11.3661056 14,10.2353738 14,9 C14,6.23857625 11.7614237,4 9,4 Z",
    id: "path-1-search"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_Heder_Red",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Search/20px/Search_Header_Red"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Searchiocon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-search",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-search"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FF5C6A",
    xlinkHref: "#path-1-search"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.f75ed7d5d1958d72d3ee30931855ef6e.svg";
export { ForwardRef as ReactComponent };